<script lang="ts" setup>
import GroupingBadge from '@/stay-displayer/grouping/common/GroupingBadge.vue'
import GroupingCard from '@/stay-displayer/grouping/common/GroupingCard.vue'
import GroupingErrorBlock from '@/stay-displayer/grouping/common/GroupingErrorBlock.vue'
import { Drg } from '@/store/modules/stay/mco/types'
import { GroupingError } from '@/store/modules/stay/types'

withDefaults(defineProps<{
  cflag: string | null
  drg?: Drg
  ecw: number
  groupingError?: GroupingError
  pccl: number | null
}>(), {
  drg: null,
  groupingError: null,
})
</script>

<template>
  <grouping-card>
    <template #left>
      <div class="badges-row">
        <grouping-badge
          label="DRG"
          :value="drg?.reference"
          :variant="groupingError ? 'error' : 'primary'"
          :title="drg?.description"
        />
        <grouping-badge
          label="ECW"
          :value="ecw"
          :variant="groupingError ? 'error' : 'secondary'"
        />
        <grouping-badge
          label="PCCL"
          :value="pccl"
          :variant="groupingError ? 'error' : 'secondary'"
        />
        <grouping-badge
          label="CFLAG"
          :value="cflag"
          :variant="groupingError ? 'error' : 'secondary'"
        />
      </div>
    </template>
    <template #right>
      <slot name="actions" />
      <grouping-error-block
        v-if="groupingError"
        :errors="[groupingError]"
      />
    </template>
  </grouping-card>
</template>

<style scoped lang="scss">
.badges-row {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 7px;
}
</style>
